import * as React from "react";

import {
  getContentHeadingLevel,
  getContentHeadingVariant,
} from "../../../utils/tools";

function Content(props: React.ComponentProps<any>) {
  return (
    <span
      className={`heading-${getContentHeadingLevel()}${getContentHeadingVariant()}`}
    >
      {props.children}
    </span>
  );
}

export default Content;
